import React from "react";
import { useField } from "formik";
import { FieldFeedbackLabel } from "./FieldFeedbackLabel";
import { get } from "lodash";

const getFieldCSSClasses = (touched, errors) => {
  const classes = ["form-control", "form-control-solid"];
  if (touched && errors) {
    classes.push("is-invalid-select");
  }

  if (touched && !errors) {
    classes.push("is-valid-select");
  }

  return classes.join(" ");
};

export function Select({
  field, // { name, value, onChange, onBlur }
  form,
  label,
  withFeedbackLabel = true,
  customFeedbackLabel,
  children,
  ...props
}) {
  const name = field?.name || props.name;
  const [formikField, meta] = useField(name || "unknown");
  
  const actualField = field || formikField;
  const touchedResult = form ? get(form.touched, actualField.name) : meta.touched;
  const errorsResult = form ? get(form.errors, actualField.name) : meta.error;

  return (
    <>
      {label && <label>{label}</label>}
      <select
        className={getFieldCSSClasses(touchedResult, errorsResult)}
        {...actualField}
        {...props}
      >
        {children}
      </select>
      {withFeedbackLabel && (
        <FieldFeedbackLabel
          erros={errorsResult}
          touched={touchedResult}
          label={label}
          customFeedbackLabel={customFeedbackLabel}
        />
      )}
    </>
  );
}
